<template>
    <div class="form__textarea__field" v-on:click="focus()" :class="{ error: !isValid}">
        <label class="form__label" :for="name" v-if="label != ''"> {{ this.label }}</label>
        <textarea class="form__textarea" :id="name" :name="name" v-model="inputField" ref="inputField" :required="required"/>
    </div>
</template>

<script>
    import InputField from "./InputField";

    export default {
        name: "TextareaField",
        extends: InputField,
    }
</script>